import React, { useState, useEffect, createRef } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CipHeader from "../Components/CipHeader";
import cogoToast from "cogo-toast";
import { kaReducer, Table } from "ka-table";
import { search, loadData, updateData } from "ka-table/actionCreators";
import { ActionType, SortingMode, PagingPosition } from "ka-table/enums";
import orderService from "../services/new-order-service";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import moment from "moment";
import { deselectAllRows, selectAllRows, selectRow, deselectRow } from "ka-table/actionCreators";
import { kaPropsUtils } from 'ka-table/utils';
import { Multiselect } from "multiselect-react-dropdown";

const tablePropsInit = {
  columns: [
    {
      key: 'selection-cell',
      isFilterable: false,
    },
    { key: "facCode", title: "Facilty Code" },
    { key: "patId", title: "Patient ID" },
    { key: "patName", title: "Patient Name" },
    { key: "rx", title: "RX" },
    { key: "drug", title: "Drug" },
    { key: "expandedSig", title: "Sig" },
    { key: "qtyRemaining1", title: "Quantity Remaining", style: { display: "none" } },
    { key: "qtyRemaining", title: "Quantity Remaining" },
    { key: "refillDueDate", title: "Refill Due Date" },
    { key: "earliestRefillDate", title: "Earliest Due Date" },
  ],
  singleAction: loadData(),
  sortingMode: SortingMode.Single,
  rowKeyField: "rxfId",
  search: ({ searchText, rowData, column }) => {
    if (column.key === "passed") {
      return (
        (searchText === "false" && !rowData.passed) ||
        (searchText === "true" && rowData.passed)
      );
    }
  },
  paging: {
    enabled: true,
    pageIndex: 0,
    pageSize: 50,
    position: PagingPosition.Bottom,
  },
};

const FacilityRefillsDue = ({ history }) => {
  const [loading, setLoading] = useState(false);

  const [tableProps, changeTableProps] = useState(tablePropsInit);
  const [refillList, setRefillList] = useState([]);
  const [facilityList, setFacilitiesList] = useState([]);
  const [facility, setFacility] = useState([]);
  const multiselectRefFacility = createRef();
  const [filters, setFilters] = useState(["ALL"]);
  const [selectedFilter, setSelectedFilter] = useState("ALL");

  const loadFilters = async () => {
    try {
      const response = await orderService.getRemoteDefaults();
      if (response?.refill_due_filters) {
        setFilters(response.refill_due_filters);
      }
    } catch (error) {
      console.error('Error loading filters:', error);
    }
  };

  const handleFilterChange = (e) => {
    const newFilter = e.target.value;
    setSelectedFilter(newFilter);
    if (facility?.length > 0 && newFilter) {
      getRefillsDueDetails(newFilter);
    }
  };

  useEffect(() => {
    loadFilters();
  }, []);

  async function getFacilities(search) {
    try {
      setLoading(true);
      setFacilitiesList([]);
      let totalFacList = await orderService.getFacilitiesForRefills(search);
      totalFacList.sort((a, b) => a.dname.localeCompare(b.dname));
      setFacilitiesList([...totalFacList]);
      setLoading(false);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error while getting facilities details. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  }
  const dispatch = async (action) => {
    changeTableProps((prevState) => kaReducer(prevState, action));
    if (action.type === ActionType.LoadData) {

    }
  };

  const CustomCellEarliestRefillDate = ({ rowData }) => {
    return (
      <div className="action_btns">
        <span className="inline-block mr-3">
          {rowData?.earliestRefillDate ? moment.utc(rowData?.earliestRefillDate).format("MM-DD-YYYY") : ""}
        </span>
      </div>
    );
  };
  const CustomCellRefillDate = ({ rowData }) => {
    return (
      <div className="action_btns">
        <span className="inline-block mr-3">
          {rowData?.refillDueDate ? moment.utc(rowData?.refillDueDate).format("MM-DD-YYYY") : ""}
        </span>
      </div>
    );
  };
  const onSubmit = async () => {
    try {
      const selectedRefills = kaPropsUtils.getSelectedData(tableProps);
      if (selectedRefills?.length === 0) {
        const { hide } = cogoToast.error(
          "Please select at least one record",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
        return;
      }
      setLoading(true);
      const selectedFillIds = selectedRefills.reduce((accumulator, currentValue) => {
        accumulator.push(currentValue.rxfId);
        return accumulator
      },
        [],
      );
      await orderService.submitRefillsDue(selectedFillIds);
      dispatch(deselectAllRows());
      setRefillList([]);
      let params = [];
      facility.forEach(item => params.push(item.id))
      let resp = await orderService.getFaciltyRefillsDue(params, selectedFilter);
      setAllselect(false);
      setRefillList(resp);
      dispatch(updateData(resp));
      setLoading(false);
    } catch (e) {
      setLoading(false);
      const { hide } = cogoToast.error(
        "Error submitting data. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  }
  async function getRefillsDueDetails(filter) {
    try {
      setLoading(true);
      let params = [];
      facility.forEach(item => params.push(item.id))
      let resp = await orderService.getFaciltyRefillsDue(params, filter);
      setRefillList([]);
      dispatch(deselectAllRows());
      setAllselect(false);
      setRefillList(resp);
      dispatch(updateData(resp));
      setLoading(false);
      if (resp?.length === 0) {
        const { hide } = cogoToast.error(
          "No records found",
          {
            hideAfter: 10,
            onClick: () => {
              hide();
            },
          }
        );
      }
    } catch (e) {
      setLoading(false);
      const { hide } = cogoToast.error(
        "Error getting data. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  }

  const SelectionHeader = (props) => {
    return (
      <input
        type='checkbox'
        checked={allselect}
        onChange={(event) => {
          if (event.currentTarget.checked) {
            dispatch(selectAllRows());
            setAllselect(true);
          } else {
            dispatch(deselectAllRows());
            setAllselect(false);
          }
        }}
      />
    );
  };
  const [allselect, setAllselect] = useState(false);

  const SelectionCell = ({ rowKeyValue, isSelectedRow, selectedRows }) => {
    return (
      <input
        type='checkbox'
        checked={isSelectedRow}
        onChange={(event) => {
          if (event.currentTarget.checked) {
            dispatch(selectRow(rowKeyValue));
          } else {
            dispatch(deselectRow(rowKeyValue));
          }
        }}
      />
    );
  };

  useEffect(() => {
    if (facility?.length > 0 && selectedFilter) {
      getRefillsDueDetails(selectedFilter);
    }
  }, [facility]);

  return (
    <>
      <CipHeader />
      <div
        className={`inline-block customtop absolute z-50 ${loading ? "show" : "hidden"
          }`}
      >
        <Loader
          type="Oval"
          color="#00BFFF"
          height={50}
          width={50}
          timeout={300000} //3 secs
        />
      </div>

      <div className="bg-white w-5/6 mx-auto mt-6 mb-4 rounded shadow-md">
        <div className="tableHeader flex clearboth shadow-md py-8 pl-3">
          <div className="w-1/2 text-darkclr font-semibold leading-10 ">
            <span className="text-xl">REFILLS DUE</span>
          </div>
          <div className="w-full sm:w-1/2 text-right">
            <span className="relative">
              <input
                type="search"
                defaultValue={tableProps.searchText}
                onChange={(event) => {
                  dispatch(search(event.currentTarget.value));
                }}
                placeholder=" Search"
                className="border rounded w-5/12 mb-2 h-10 mb--3 mr-3 focus:outline-none focus:none pl-1 font-light align-bottom"
              />
              <img
                src="/img/search-2.svg"
                alt=""
                className={`absolute w-4 h-4  right-5 bottom-5 `}
              ></img>
            </span>
          </div>
        </div>

        <div className="flex flex-row py-3 gap-10 justify-center items-center">
          <div className="w-1/2 items-center px-2">
            <label className="text-labelclr font-semibold text-md tracking-wider p-2">
              Select Facility
            </label>
            <div className="w-full">  {facilityList ? (
              <Multiselect
                name="faciltyList"
                displayValue="dname"
                selectedValues={facility}
                options={facilityList}
                ref={multiselectRefFacility}
                avoidHighlightFirstOption={true}
                selectionLimit={1}
                hidePlaceholder={true}
                placeholder="Start typing the name"
                caseSensitiveSearch={true}
                onSelect={(selectedList, selectedItem) => {
                  setFacility([selectedItem]);
                }}
                onSearch={(value) => {
                  getFacilities(value);
                }}
                onRemove={() => {
                  setFacility([]);
                }}
              />
            ) : (
              ""
            )}
            </div>
          </div>
          <div className="w-1/2">
            <label className="text-labelclr font-semibold text-md tracking-wider p-2">
              Select Filter
            </label>
            <div className="flex-none w-48 mr-3">
              <select
                name="defaultFilters"
                aria-label="Select Filter"
                value={selectedFilter}
                onChange={handleFilterChange}
                className="border focus:outline-none h-10 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
              >
                {filters
                  ? filters?.map((item, i) => {
                    return (
                      <option key={i} value={item}>
                        {item}
                      </option>
                    );
                  })
                  : null}
              </select>
            </div>
          </div>

        </div>

        {refillList?.length > 0 && <div className="p-2 text-xs usersList gridList overflow-x-auto">
          <Table
            className="table-fixed"
            {...tableProps}
            childComponents={{
              cellText: {
                content: (props) => {
                  // eslint-disable-next-line default-case
                  switch (props.column.key) {
                    case "selection-cell":
                      return <SelectionCell {...props} />
                    case "earliestRefillDate":
                      return <CustomCellEarliestRefillDate {...props} />;
                    case "refillDueDate":
                      return <CustomCellRefillDate {...props} />;

                  }
                },
              },
              headCell: {
                content: (props) => {
                  if (props.column.key === 'selection-cell') {
                    return <SelectionHeader {...props} />;
                  }
                },
              },
            }}
            dispatch={dispatch}
          />
        </div>}
        {refillList?.length > 0 && <div className="mx-3">
          <button
            disabled={loading}
            className={
              refillList?.length === 0 || loading
                ? "opacity-50 cursor-not-allowed text-rounded font-medium h-10 text-white w-full bg-login_btn my-3 focus:outline-none text-sm"
                : "rounded font-medium h-10 text-white w-full bg-login_btn my-3 focus:outline-none text-sm"
            }
            onClick={() => onSubmit()}
          >
            SUBMIT
          </button>
        </div>}
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(FacilityRefillsDue)
);
